import { FC } from "react";
import { Box, Button, Container, Divider, Flex } from "@chakra-ui/react";
import { HeadButton } from "../../../customComponents/components/HeadButton";

export const PageHead: FC<{
  children: React.ReactNode;
  linkLabel?: string | number;
  onClick?: () => void;
  infoElement?: string;
  breadCrumbs: React.ReactNode;
}> = ({ children, linkLabel, onClick, breadCrumbs, infoElement }) => (
  <>
    <Box bg="#F7F7F7" borderBottom={"1px solid #A6A8AE"}>
      <Container maxWidth="1160px">
        <Flex justify="space-between" alignItems={"center"} h="110px">
          {breadCrumbs}
          <Flex alignItems='flex-end' gap='8px'>
            {linkLabel && (
              <HeadButton onClick={onClick}>{linkLabel}</HeadButton>
            )}
            {infoElement && <Button>{infoElement}</Button>}
          </Flex>
        </Flex>
      </Container>
    </Box>
    <Divider marginTop={"20px"} marginBottom={"20px"} />
    <Container maxWidth="1160px" padding="0">
      {children}
    </Container>
  </>
);
